/**
 * /pages/Invoices.js – Работа c накладными
 * /stores/invoices.js – бизнес логика
 * 
 * Отображается по налкданым данного предприятия
 * 
 * Работа с накладными является двух ступенчатой
 *  - пользователь с правом ____ может создавать накладные
 *  - после этого пользователь с правом ___ должен проверит и подтвердить накладную, после этого происходит оприходование накладных на склад
 *  - есть возмодность отметить накладную как оплаченую, эта информация будет отображаться в платежном календаре, расчет даты оплаты происходит автоматически
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { confirmState } from '../stores/common';
import { InvoicePaymentTypes, InvoiceState, InvoiceStatuses, InvoiceTypes } from '../stores/invoices';
import { InvoiceApi, ProviderApi, ShopListApi } from '../stores/apiMethods';

import { toSelectList, formatDate, getVATList } from '../functions';

import { TableReportPage } from './PageTemplates';
import { AddButton, CreateButton, FilterIconButton, ItemNewHeader, MainFilterBlock, PayButton, RemoveIconButton } from '../shared/PageComponents';
import { EmptyResultInformer, FormModal } from '../shared/FeedbackComponents';
import { Selectize, TextInput, DateInput } from '../forms/FormItems';
import { DocumentInfoRow, DocumentStatusInfo } from '../shared/StockComponents';
import { CalendarIcon, ProviderIcon, StockIcon, WalletIcon } from '../images/icons';


/** Работа с накладными */
export class InvoicePage extends Component {
	constructor(props) {
		super(props);
		this.store = new InvoiceState();
		this.state = { isOpen : false };
	}

	componentDidMount() {
		this.getData();
		ProviderApi.getList(true, (data) => { this.store.Providers = data.Success && !_.isNull(data.Providers) ? data.Providers : []; });
		ShopListApi.getList({ Status : 2 }, (data) => {
			this.store.ShopListList = data.Success && !_.isNull(data.ShopLists) ? data.ShopLists : [];
		});
	}

	/** API запрос «Invoices» на получение списка накладных */
	getData = () => {
		this.store.IsSendRequest = false;
		InvoiceApi.getList(this.store.Filter.getData(), (data) => { this.store.setInvoices(data); });
	}

	/**
	 * API запрос «Invoice» на получение накладной
	 * @param {number} id ID накладной
	 */
	getItem = (id, errorCode = "") => {
		InvoiceApi.getById(id, (data) => {
			this.store.setInvoice(data.Success ? data : undefined);
			if (data.Success && errorCode) this.store.Invoice.ErrorCode = errorCode;
		});
	}

	/**
	 * API запрос «PaymentInvoice» для оплаты накладной
	 * @param {number} id ID накладной
	 */
	paymentInvoice = (id) => {
		if (_.isUndefined(id)) return false;

		var item = _.find(this.store.Invoices, { Id : id }),
			text = <span>Вы действительно хотите оплатить накладную&nbsp;<b key="b1">«{item.InvoiceNumber}»</b>?</span>;

		confirmState.openConfirm(text, () => { InvoiceApi.pay(id, () => { this.getData(); }); });
	}

	/** Открытие конкретной накладной */
	setId = (id) => {
		if (!_.isUndefined(id)) {
			if (id !== -1) this.getItem(id)
			else this.store.setInvoice({ Id: -1 });
		} else {
			this.store.setInvoice();
			this.getData();
		}
	}

	/**
	 * Смена страницы
	 * @param {number} offset 
	 */
	changePage = (offset) => {
		this.store.Filter.Offset = offset;
		this.getData();
	}

	/** Удаление накладной */
	removeId = (id) => {
		if (_.isUndefined(id)) return false;

		var item = _.find(this.store.Invoices, { Id : id }),
			text = <span>Вы действительно хотите удалить накладную&nbsp;<b key="b1">«{item.InvoiceNumber}»</b>?</span>;

		confirmState.openConfirm(text, () => { InvoiceApi.remove(id, () => { this.getData(); }); });
	}

	render() {
		return (
			<div className="page" id="InvoicePage">
				{_.isUndefined(this.store.Invoice) &&
					<>
						<div className="head">
							<div>
								<h2>Накладные</h2>
								{this.store.CanView &&
									<CreateButton Title="Создать накладную" onClick={() => this.setId(-1)} />
								}
								<FilterIconButton IsOpen={this.state.isOpen}
									onClick={() => this.setState({ isOpen: !this.state.isOpen })} />
							</div>
							<InvoiceFilter
								Filter={this.store.Filter}
								Providers={this.store.Providers}
								Stocks={this.store.Stocks}
								IsOpen={this.state.isOpen}
								getData={this.getData}
							/>
						</div>
						{this.store.IsSendRequest && (_.isEmpty(this.store.Invoices)
							? <EmptyResultInformer />
							: <TableReportPage
								TableData={this.store.Invoices}
								Type="Invoices"
								TableColumns={this.store.columns}
								FilterHeight={this.state.isOpen ? 125 : 0}
								Pagination={true}
								Limit={this.store.Filter.Limit}
								HasMore={this.store.HasMore}
								Offset={this.store.Filter.Offset}
								
								changePage={this.changePage}
								editRow={this.setId}
								payRow={this.paymentInvoice}
								removeRow={this.removeId}

								getTrProps={(state, rowInfo, column) => {
									return { className : rowInfo.original.StatusColor }
								}}
							/>
						)}
					</>
				}
				{!_.isUndefined(this.store.Invoice) &&
					<InvoiceItem
						Invoice={this.store.Invoice}
						ShopLists={this.store.ShopLists}
						Stocks={this.store.Stocks}
						Providers={this.store.Providers}
						getItem={this.getItem}
						handleClose={() => this.setId()}
					/>
				}
			</div>
		)
	}
}
InvoicePage = observer(InvoicePage);


class InvoiceFilter extends Component {
	/** Отправка формы */
	handleSubmit = () => {
		this.props.Filter.Offset = 0;
		this.props.getData();
	}

	render() {
		return(
			<MainFilterBlock Filter={this.props.Filter} IsOpen={this.props.IsOpen}
				IsPartialOpen={false} onSubmit={this.handleSubmit}>
				<Selectize 
					Id="ProviderId"
					Title="Поставщик"
					List={toSelectList(this.props.Providers)}
					Value={this.props.Filter.ProviderId}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
				<Selectize 
					Id="StockId"
					Title="Склад"
					List={toSelectList(this.props.Stocks)}
					Value={this.props.Filter.StockId}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
				<Selectize 
					Id="Status"
					Title="Статус"
					List={toSelectList(InvoiceStatuses)}
					Value={this.props.Filter.Status}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
				<DateInput 
					Id="Date"
					Title="Дата создания накладной"
					Value={this.props.Filter.Date}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
			</MainFilterBlock>
		)
	}
}
InvoiceFilter = observer(InvoiceFilter);

class InvoiceItem extends Component {
	componentDidMount() {
		if (this.props.Invoice.Id !== -1 && this.props.Invoice.Status === 1)
			this.getProvider(this.props.Invoice.ProviderId);
	}

	/**
	 * API запрос «Provider» на получение информации о выбранном поставщике
	 * @param {number} id ID поставщика
	 */
	getProvider = (id) => {
		if (id === "" || id === -1) {
			this.props.Invoice.ProviderProducts = [];
			this.props.Invoice.ButtonLoading = false;
			return;
		}

		this.props.Invoice.ButtonLoading = true;
		ProviderApi.getById(id, (data) => {
			this.props.Invoice.setProviderData(data.Success ? data : {});
			this.props.Invoice.ButtonLoading = false;
		});
	}

	/** Обработка клика на кнопку «Сохранить» */
	handleSubmit = (event) => {
		event.preventDefault();
		const submitter = event.nativeEvent && event.nativeEvent.submitter,
			action = submitter && submitter.dataset ? submitter.dataset.action : "save";

		if (action === "accept") {
			this.props.Invoice.ConfirmOpen = true;
		} else this.saveInvoice();
	}

	/**
	 * API запрос «SaveInvoice» на сохранение накладной
	 * @param {string} type тип запроса — с подтверждением или без
	 */
	saveInvoice = (type) => {
		if (!this.props.Invoice.validate())
			return false;

		this.props.Invoice.ErrorCode = "";
		this.props.Invoice.SuccessSave = false;
		this.props.Invoice.ButtonLoading = true;
		InvoiceApi.save(this.props.Invoice.getData(), (data) => {
			this.props.Invoice.SuccessSave = data.Success;
			if (data.Success) {
				if (type === "accept") this.acceptInvoice();
				else {
					this.props.Invoice.Id = data.Id;
					this.props.Invoice.ErrorCode = "SUCCESS_SAVE";
					this.props.Invoice.ButtonLoading = false;
				}
			} else {
				this.props.Invoice.ErrorCode = data.ErrorCode;
				this.props.Invoice.ButtonLoading = false;
			}
		})
	}

	/** API запрос «AcceptInvoice» на подтверждение накладной */
	acceptInvoice = () => {
		const id = this.props.Invoice.Id;
		this.props.Invoice.ConfirmLoading = true;
		InvoiceApi.accept(id, (data) => {
			this.props.Invoice.ButtonLoading = false;
			this.props.Invoice.ConfirmLoading = false;
			this.props.Invoice.ConfirmOpen = false;
			if (data.Success) this.props.getItem(id);
			else this.props.getItem(id, data.ErrorCode);
		})
	}

	/**
	 * API запрос «ShopList» на получение состава списка покупок
	 * @param {number} value ID спика покупок
	 */
	changeShopList = (value) => {
		this.props.Invoice.ShopListId = value;
		if (value === -1 || value === "") return false;

		ShopListApi.getById(value, (data) => {
			if (data.Success) {
				this.props.Invoice.setShopListData(data);
				this.getProvider(data.ProviderId);
			}
		})
	}

	render() {
		return (
			<section className="clearfix item" id="InvoiceItem">
				<form onSubmit={this.handleSubmit}>
					<ItemNewHeader
						Title={this.props.Invoice.pageTitle}
						ErrorCode={this.props.Invoice.ErrorCode}
						ButtonLoading={this.props.Invoice.ButtonLoading}
						CanManage={this.props.Invoice.CanManage}
						CanAccept={this.props.Invoice.CanAccept}
						SuccessSave={this.props.Invoice.SuccessSave}
						handleClose={this.props.handleClose}
					/>
					{this.props.Invoice.Id === -1 && !_.isEmpty(this.props.ShopLists) &&
						<div className="backblock">
							<Selectize 
								Id="ShopListId"
								Value={this.props.Invoice.ShopListId}
								Title="Создать на базе закупки"
								List={toSelectList(this.props.ShopLists)}
								onChange={this.changeShopList}
							/>
						</div>
					}
					<div className='info'>
						{this.props.Invoice.CanManage ?
							<MainSettings Invoice={this.props.Invoice} Stocks={this.props.Stocks}
								Providers={this.props.Providers} getProvider={this.getProvider} />
							: <InvoiceInfoBlock Invoice={this.props.Invoice} getItem={this.props.getItem} />
						}
					</div>
					<ProductInvoiceBlock Invoice={this.props.Invoice} />
				</form>
				{this.props.Invoice.ConfirmOpen &&
					<InvoiceConfirm Invoice={this.props.Invoice} onConfirm={this.saveInvoice} />
				}
			</section>
		)
	}
}
InvoiceItem = observer(InvoiceItem);

/** Блок с основными настройками накладной */
class MainSettings extends Component {
	render() {
		const invoice = this.props.Invoice;
		return(
			<>
				<div className="section settings">
					<Selectize 
						Id="InvoiceType"
						Title="Тип накладной"
						List={toSelectList(InvoiceTypes)}
						Value={invoice.InvoiceType}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
					<TextInput
						Id="InvoiceNumber"
						Title="Номер накладной"
						Value={invoice.InvoiceNumber}
						Required={true}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
					<DateInput
						Id="Date"
						Title="Дата накладной"
						Value={invoice.Date}
						Required={true}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
					<Selectize 
						Id="StockId"
						Title="Склад"
						List={toSelectList(this.props.Stocks)}
						Value={invoice.StockId}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
					<Selectize 
						Id="ProviderId"
						Title="Поставщик"
						List={toSelectList(this.props.Providers)}
						Value={invoice.ProviderId}
						onChange={(value, id) => {invoice.collect(id, value); this.props.getProvider(value)}}
					/>
					<TextInput
						Id="Description"
						Title="Комментарий"
						Type="textarea"
						Value={invoice.Description}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
				</div>
				<div className="section">
					<h5>Оплата</h5>
					<Selectize 
						Id="PaymentType"
						Title="Тип оплаты"
						List={toSelectList(InvoicePaymentTypes)}
						Value={invoice.PaymentType}
						onChange={(value, id) => invoice.collect(id, value)}
					/>
				</div>
			</>
		)
	}
}
MainSettings = observer(MainSettings);

/** Блок с общей информацией нерадктируемой */
class InvoiceInfoBlock extends Component {
	/** API запрос оплаты накладной */
	handlePay = () => {
		var invoice = this.props.Invoice,
			text = <span>Вы действительно хотите оплатить накладную&nbsp;
				<b key="b1">«{invoice.Title}»</b>?</span>;

		confirmState.openConfirm(text, () => {
			InvoiceApi.pay(invoice.Id, (data) => {
				if (data.Success) this.props.getItem(invoice.Id);
				else invoice.ErrorCode = data.ErrorCode;
			})
		});
	}

	render() {
		var invoice = this.props.Invoice;

		return (
			<>
				<DocumentStatusInfo
					Active={true}
					ActiveTitle="Создано"
					User={invoice.User}
					Date={formatDate(invoice.Date)}
					ClassName="create"
				>
					<DocumentInfoRow Title="Склад">{invoice.Stock}</DocumentInfoRow>
					<DocumentInfoRow Title="Поставщик">{invoice.Provider}</DocumentInfoRow>
					{invoice.Description !== "" &&
						<DocumentInfoRow Title="Комментарий">{invoice.Description}</DocumentInfoRow>
					}
				</DocumentStatusInfo>
				<DocumentStatusInfo
					Active={invoice.isAccepted}
					ActiveTitle="Подтверждено"
					InactiveTitle="Не подтверждено"
					User={invoice.AcceptUser}
					Date={formatDate(invoice.AcceptDate)}
					ClassName="accept"
				/>
				<DocumentStatusInfo
					Active={invoice.isPaid}
					ActiveTitle="Оплачено"
					InactiveTitle="Не оплачено"
					User={invoice.PaymentUser}
					Date={formatDate(invoice.PaymentDate)}
					ClassName="payment"
				>
					<DocumentInfoRow Title="К оплате">
						{invoice.Products.Amount}
						<span className="paymentTypeIcon" title={invoice.PaymentTitle}>{invoice.PaymentIcon}</span>
					</DocumentInfoRow>
					{!invoice.isPaid &&
						<DocumentInfoRow Title="Оплатить до">
							{formatDate(invoice.DeadlinePayment)},
							{invoice.paymentDaysLeft > 0 ?
								<span> Осталось {invoice.paymentDaysLeft} дней</span>
								: <span> Оплата просрочена</span>
							}
						</DocumentInfoRow>
					}
					{!invoice.isPaid && invoice.CanPay &&
						<PayButton Expired={invoice.paymentDaysLeft <= 0} onClick={this.handlePay} />
					}
				</DocumentStatusInfo>
			</>
		)
	}
}
InvoiceInfoBlock = observer(InvoiceInfoBlock)

/** Блок с информацией по товарам */
class ProductInvoiceBlock extends Component {
	render() {
		const invoice = this.props.Invoice;
		return(
			<div className="invoiceList section">
				<h4>Заказ</h4>
				<div className={"products" + (!invoice.CanManage ? " read" : "")}>
					<span className="title">Сырье</span>
					<span className="title">Кол-во (н)</span>
					<span className="title">Кол-во (б)</span>
					<span className="title">Цена за ед.</span>
					<span className="title">Сумма</span>
					<span className="title">НДС, %</span>
					<span className="title">НДС, руб.</span>
					{invoice.CanManage && <span>&nbsp;</span>}
					{_.map(invoice.Products.List, (product, i) => {
						return invoice.CanManage
							? <ProductInvoiceItem key={"p" + i} Index={i} Item={product}
								Products={invoice.Products} ProviderProducts={invoice.ProviderProducts} />
							: <ProductInfoItem key={"p" + i} Item={product} />
					})}
				</div>
				{invoice.CanManage &&
					<AddButton Title="Добавить сырье" onClick={() => invoice.Products.addItem()} />
				}
				<SummaryBlock Products={invoice.Products} CanManage={invoice.CanManage} />
			</div>
		)
	}
}
ProductInvoiceBlock = observer(ProductInvoiceBlock);

class ProductInvoiceItem extends Component {
	render() {
		const products = this.props.Products;
		return(
			<>
				<Selectize 
					Id="ProductId"
					List={toSelectList(this.props.ProviderProducts)}
					Value={this.props.Item.ProductId}
					onChange={(value, id) => products.collect(id, value, this.props.Index,
						_.find(this.props.ProviderProducts, { Id : value }))}
				/>
				<TextInput 
					Id="Count"
					Value={this.props.Item.Count}
					Icon={this.props.Item.UnitNet}
					IconType="text"
					Required={true}
					Type="number"
					Step="0.001"
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				<TextInput 
					Id="CountGross"
					Value={this.props.Item.CountGross}
					Icon={this.props.Item.UnitGross}
					IconType="text"
					Type="number"
					Step="0.001"
					Required={true}
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				<TextInput 
					Id="Price"
					Value={this.props.Item.Price}
					Type="number"
					Step="0.01"
					Required={true}
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				<TextInput 
					Id="Amount"
					Value={this.props.Item.Amount}
					Type="number"
					Step="0.01"
					Required={true}
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				<Selectize 
					Id="VAT"
					List={getVATList(this.props.Item.VAT)}
					Value={this.props.Item.VAT}
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				<TextInput 
					Id="VATAmount"
					Value={this.props.Item.VATAmount}
					Type="number"
					Step="0.01"
					Required={true}
					onChange={(value, id) => products.collect(id, value, this.props.Index)}
				/>
				{products.List.length > 1 &&
					<RemoveIconButton onClick={() => products.removeItem(this.props.Index)} />
				}
			</>
		)
	}
}
ProductInvoiceItem = observer(ProductInvoiceItem);

class ProductInfoItem extends Component {
	render() {
		return(
			<>
				<span>{this.props.Item.ProductName}</span>
				<span>{this.props.Item.Count} {this.props.Item.UnitNet}</span>
				<span>{this.props.Item.CountGross} {this.props.Item.UnitGross}</span>
				<span>{this.props.Item.Price}</span>
				<span>{this.props.Item.Amount}</span>
				<span>{this.props.Item.VATTitle}</span>
				<span>{this.props.Item.VATAmount}</span>
			</>
		)
	}
}

class SummaryBlock extends Component {
	render() {
		if (this.props.CanManage) return(
				<div className="summary">
					<h4>Итого</h4>
					<TextInput
						Id="Amount"
						Title="Сумма накладной"
						Value={this.props.Products.Amount}
						Required={true}
						onChange={(value, id) => this.props.Products.collect(id, value)}
					/>
					<TextInput
						Id="VATAmount"
						Title="В т.ч. НДС"
						Value={this.props.Products.VATAmount}
						Required={true}
						onChange={(value, id) => this.props.Products.collect(id, value)}
					/>
				</div>)
		else return(
			<div className="summary">
				<h4>Итого</h4>
				<div>
					<span className='title'>Сумма накладной</span>
					<span>{this.props.Products.Amount} руб.</span>
				</div>
				<div>
					<span className='title'>В т.ч. НДС</span>
					<span>{this.props.Products.VATAmount} руб.</span>
				</div>
			</div>
		)	
	}
}
SummaryBlock = observer(SummaryBlock);

class InvoiceConfirm extends Component {
	onConfirm = () => {
		this.props.onConfirm("accept");
	}

	render() {
		var invoice = this.props.Invoice,
			text = <span>Вы действительно хотите подтвердить накладную&nbsp;
				<b key="b1">«{invoice.Title}»</b>?</span>;

		return(
			<FormModal
				Id="InvoiceConfirm"
				Title={text}
				ClassName="medium"
				Loading={invoice.ConfirmLoading}
				onSubmit={this.onConfirm}
				onClose={() => invoice.ConfirmOpen = false}
			>
				<p><CalendarIcon />{formatDate(invoice.Date)}</p>
				<p><ProviderIcon />Поставщик <b>{invoice.Provider}</b></p>
				<p><StockIcon />Склад <b>{invoice.Stock}</b></p>
				<p><WalletIcon />Сумма {invoice.Products.Amount} руб.</p>
			</FormModal>
		)
	}
}
InvoiceConfirm = observer(InvoiceConfirm);
